/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import type { IMetadata, IPortalAccountEmailAddress, IPortalAccountPhoneNumber, IPortalAccount } from '../../api/domain';

enum PortalAccountApiActions {
    FETCH_USER_PORTAL_ACCOUNT = 'portal-account-api.fetch.user-portal-account',
    FETCH_USER_PORTAL_ACCOUNT_SUCCESS = 'portal-account-api.fetch.user-portal-account-success',
    FETCH_USER_PORTAL_ACCOUNT_FAILURE = 'portal-account-api.fetch.user-portal-account-failure',

    FETCH_PORTAL_ACCOUNTS = 'portal-account-api.fetch.portal-accounts',
    FETCH_PORTAL_ACCOUNTS_SUCCESS = 'portal-account-api.fetch.portal-accounts-success',
    FETCH_PORTAL_ACCOUNTS_FAILURE = 'portal-account-api.fetch.portal-accounts-failure',

    UPDATE_ACCOUNT_EMAIL = 'portal-account-api.update-email',
    UPDATE_ACCOUNT_EMAIL_SUCCESS = 'portal-account-api.update-email.success',
    UPDATE_ACCOUNT_EMAIL_FAILURE = 'portal-account-api.update-email.failure',

    UPDATE_OR_ADD_SINGLE_ACCOUNT_METADATA = 'portal-account-api.update-or-add-single-metadata',
    UPDATE_OR_ADD_SINGLE_ACCOUNT_METADATA_SUCCESS = 'portal-account-api.update-or-add-single-metadata.success',
    UPDATE_OR_ADD_SINGLE_ACCOUNT_METADATA_FAILURE = 'portal-account-api.update-or-add-single-metadata.failure',

    UPDATE_ACCOUNT_METADATA = 'portal-account-api.update-metadata',
    UPDATE_ACCOUNT_METADATA_SUCCESS = 'portal-account-api.update-metadata.success',
    UPDATE_ACCOUNT_METADATA_FAILURE = 'portal-account-api.update-metadata.failure',

    DELETE_ACCOUNT_EMAIL = 'portal-account-api.delete-email',
    DELETE_ACCOUNT_EMAIL_SUCCESS = 'portal-account-api.delete-email.success',
    DELETE_ACCOUNT_EMAIL_FAILURE = 'portal-account-api.delete-email.failure',

    CREATE_ACCOUNT_EMAIL = 'portal-account-api.create-email',
    CREATE_ACCOUNT_EMAIL_SUCCESS = 'portal-account-api.create-email.success',
    CREATE_ACCOUNT_EMAIL_FAILURE = 'portal-account-api.create-email.failure',

    UPDATE_ACCOUNT_PHONE_NUMBER = 'portal-account-api.update-phonenumber',
    UPDATE_ACCOUNT_PHONE_NUMBER_SUCCESS = 'portal-account-api.update-phonenumber.success',
    UPDATE_ACCOUNT_PHONE_NUMBER_FAILURE = 'portal-account-api.update-phonenumber.failure',

    DELETE_ACCOUNT_PHONE_NUMBER = 'portal-account-api.delete-phonenumber',
    DELETE_ACCOUNT_PHONE_NUMBER_SUCCESS = 'portal-account-api.delete-phonenumber.success',
    DELETE_ACCOUNT_PHONE_NUMBER_FAILURE = 'portal-account-api.delete-phonenumber.failure',

    CREATE_ACCOUNT_PHONE_NUMBER = 'portal-account-api.create-phonenumber',
    CREATE_ACCOUNT_PHONE_NUMBER_SUCCESS = 'portal-account-api.create-phonenumber.success',
    CREATE_ACCOUNT_PHONE_NUMBER_FAILURE = 'portal-account-api.create-phonenumber.failure',

    SET_MAIL_NOTIFICATIONS_ENABLED = 'portal-account-api.set-mail-notifications',
    SET_MAIL_NOTIFICATIONS_ENABLED_SUCCESS = 'portal-account-api.set-mail-notifications.success',
    SET_MAIL_NOTIFICATIONS_ENABLED_FAILURE = 'portal-account-api.set-mail-notifications.failure',
    SET_PHONE_NOTIFICATIONS_ENABLED = 'portal-account-api.set-phone-notifications',
    SET_PHONE_NOTIFICATIONS_ENABLED_SUCCESS = 'portal-account-api.set-phone-notifications.success',
    SET_PHONE_NOTIFICATIONS_ENABLED_FAILURE = 'portal-account-api.set-phone-notifications.failure',
}

export const fetchUserPortalAccount = createAction(PortalAccountApiActions.FETCH_USER_PORTAL_ACCOUNT);
export const fetchUserPortalAccountSuccess = createAction<IPortalAccount>(PortalAccountApiActions.FETCH_USER_PORTAL_ACCOUNT_SUCCESS);
export const fetchUserPortalAccountFailure = createAction(PortalAccountApiActions.FETCH_USER_PORTAL_ACCOUNT_FAILURE);

export const fetchPortalAccounts = createAction<string[]>(PortalAccountApiActions.FETCH_PORTAL_ACCOUNTS);
export const fetchPortalAccountsSuccess = createAction<IPortalAccount[]>(PortalAccountApiActions.FETCH_PORTAL_ACCOUNTS_SUCCESS);
export const fetchPortalAccountsFailure = createAction(PortalAccountApiActions.FETCH_PORTAL_ACCOUNTS_FAILURE);

export const createAccountEmail = createAction<IPortalAccountEmailAddress>(PortalAccountApiActions.CREATE_ACCOUNT_EMAIL);
export const createAccountEmailSuccess = createAction(PortalAccountApiActions.CREATE_ACCOUNT_EMAIL_SUCCESS);
export const createAccountEmailFailure = createAction(PortalAccountApiActions.CREATE_ACCOUNT_EMAIL_FAILURE);

export const updateAccountEmail = createAction<IPortalAccountEmailAddress>(PortalAccountApiActions.UPDATE_ACCOUNT_EMAIL);
export const updateAccountEmailSuccess = createAction(PortalAccountApiActions.UPDATE_ACCOUNT_EMAIL_SUCCESS);
export const updateAccountEmailFailure = createAction(PortalAccountApiActions.UPDATE_ACCOUNT_EMAIL_FAILURE);

export const updateOrAddSingleAccountMetadata = createAction<IMetadata>(PortalAccountApiActions.UPDATE_OR_ADD_SINGLE_ACCOUNT_METADATA);
export const updateOrAddSingleAccountMetadataSuccess = createAction(PortalAccountApiActions.UPDATE_OR_ADD_SINGLE_ACCOUNT_METADATA_SUCCESS);
export const updateOrAddSingleAccountMetadataFailure = createAction(PortalAccountApiActions.UPDATE_OR_ADD_SINGLE_ACCOUNT_METADATA_FAILURE);

export const updateAccountMetadata = createAction<IMetadata[]>(PortalAccountApiActions.UPDATE_ACCOUNT_METADATA);
export const updateAccountMetadataSuccess = createAction(PortalAccountApiActions.UPDATE_ACCOUNT_METADATA_SUCCESS);
export const updateAccountMetadataFailure = createAction(PortalAccountApiActions.UPDATE_ACCOUNT_METADATA_FAILURE);

export const deleteAccountEmail = createAction<string>(PortalAccountApiActions.DELETE_ACCOUNT_EMAIL);
export const deleteAccountEmailSuccess = createAction(PortalAccountApiActions.DELETE_ACCOUNT_EMAIL_SUCCESS);
export const deleteAccountEmailFailure = createAction(PortalAccountApiActions.DELETE_ACCOUNT_EMAIL_FAILURE);

export const createAccountPhoneNumber = createAction<IPortalAccountPhoneNumber>(PortalAccountApiActions.CREATE_ACCOUNT_PHONE_NUMBER);
export const createAccountPhoneNumberSuccess = createAction(PortalAccountApiActions.CREATE_ACCOUNT_PHONE_NUMBER_SUCCESS);
export const createAccountPhoneNumberFailure = createAction(PortalAccountApiActions.CREATE_ACCOUNT_PHONE_NUMBER_FAILURE);

export const updateAccountPhoneNumber = createAction<IPortalAccountPhoneNumber>(PortalAccountApiActions.UPDATE_ACCOUNT_PHONE_NUMBER);
export const updateAccountPhoneNumberSuccess = createAction(PortalAccountApiActions.UPDATE_ACCOUNT_PHONE_NUMBER_SUCCESS);
export const updateAccountPhoneNumberFailure = createAction(PortalAccountApiActions.UPDATE_ACCOUNT_PHONE_NUMBER_FAILURE);

export const deleteAccountPhoneNumber = createAction<string>(PortalAccountApiActions.DELETE_ACCOUNT_PHONE_NUMBER);
export const deleteAccountPhoneNumberSuccess = createAction(PortalAccountApiActions.DELETE_ACCOUNT_PHONE_NUMBER_SUCCESS);
export const deleteAccountPhoneNumberFailure = createAction(PortalAccountApiActions.DELETE_ACCOUNT_PHONE_NUMBER_FAILURE);

export const setMailNotificationsEnabled = createAction<boolean>(PortalAccountApiActions.SET_MAIL_NOTIFICATIONS_ENABLED);
export const setMailNotificationsEnabledSuccess = createAction(PortalAccountApiActions.SET_MAIL_NOTIFICATIONS_ENABLED_SUCCESS);
export const setMailNotificationsEnabledFailure = createAction(PortalAccountApiActions.SET_MAIL_NOTIFICATIONS_ENABLED_FAILURE);

export const setPhoneNotificationsEnabled = createAction<boolean>(PortalAccountApiActions.SET_PHONE_NOTIFICATIONS_ENABLED);
export const setPhoneNotificationsEnabledSuccess = createAction(PortalAccountApiActions.SET_PHONE_NOTIFICATIONS_ENABLED_SUCCESS);
export const setPhoneNotificationsEnabledFailure = createAction(PortalAccountApiActions.SET_PHONE_NOTIFICATIONS_ENABLED_FAILURE);
